import { render, staticRenderFns } from "./reservation.vue?vue&type=template&id=65c61805&scoped=true"
import script from "./reservation.vue?vue&type=script&lang=js"
export * from "./reservation.vue?vue&type=script&lang=js"
import style0 from "./reservation.vue?vue&type=style&index=0&id=65c61805&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c61805",
  null
  
)

export default component.exports